import domReady from '@wordpress/dom-ready';
import tippy from 'tippy.js';

domReady(() => {
	const comparisonListItemSelector = '.js-comparison-list-item';

	const comparisonListItems = document.querySelectorAll(`${comparisonListItemSelector}[data-tooltip]`);

	if (!comparisonListItems.length) {
		return;
	}

	comparisonListItems.forEach((item) => {
		tippy(item.querySelector('.typography'), {
			content: item?.dataset?.tooltip ?? '',
			animation: 'shift-away',
			theme: 'translucent productive',
			maxWidth: 240,
		});
	});
});
